import { useMemo } from 'react';
import MojitoModules from 'mojito/modules';
import { uniq } from 'mojito/utils';

const { MATCH } = MojitoModules.EventCards.types.CARD_TYPE;
const { useCardsPromotions } = MojitoModules.EventCardsCarousel.Hooks;
const { usePromotionsContainerCards, usePromotionsContainerLoadDone } =
    MojitoModules.Promotions.hooks;

/**
 * Resolves CMS match cards and sport ids for the vertical feed.
 *
 * @param {object} config - FeedView configuration.
 * @returns {{ cardsToRender: Array<object>, sportIds: Array<string>, promotionsLoaded: boolean }} Match cards to render, sport ids for the feed filter, and whether promotions finished loading.
 */
export function useFeedViewCards(config) {
    const { containerId, applicablePage, priorityType } = config;
    const cardPromotions = usePromotionsContainerCards(containerId, applicablePage);
    const cards = useCardsPromotions(cardPromotions, priorityType?.value);
    const promotionsLoaded = usePromotionsContainerLoadDone(containerId);
    const cardsToRender = useMemo(() => cards.filter(card => card.type === MATCH), [cards]);
    const sportIds = useMemo(
        () => uniq(cardsToRender.map(card => card.sportId).filter(Boolean)),
        [cardsToRender]
    );

    return { cardsToRender, sportIds, promotionsLoaded };
}
